import React, {useState} from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import { useTranslation } from 'react-i18next';

import Construct from "../../Construct";
import ClearFilterBtn from "../../../application/ClearFilterBtn";

import {styled, lighten, Toolbar, Typography, Tooltip} from '@mui/material';
import IconButton from "@mui/material/IconButton";
import AddIcon from '@mui/icons-material/Add';
import {appSetModalContent} from "../../../../redux/app/appActions";
import {useDispatch} from "react-redux";


const PREFIX = 'SmartTableToolbar';

const classes = {
    root: `${PREFIX}-root`,
    highlight: `${PREFIX}-highlight`,
    headerContent: `${PREFIX}-headerContent`,
    title: `${PREFIX}-title`,
    headerAction: `${PREFIX}-headerAction`
};

const StyledToolbar = styled(Toolbar)((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        display: 'flex',
        paddingTop: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        alignItems: 'self-start'
    },

    [`& .${classes.highlight}`]: theme.palette.mode === 'light'
        ? {
            color: theme.palette.secondary.main,
            backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
        : {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.secondary.dark,
        },

    [`& .${classes.headerContent}`]: {
        flex: '1 1 auto'
    },

    [`& .${classes.title}`]: {
        flex: '1 1 100%',
        alignItems: 'start',
        textAlign: 'left',
        textTransform: 'none',
    },

    [`& .${classes.headerAction}`]: {
        marginTop: '-8px',
        marginRight: '-8px',
        marginLeft: 'auto'
    }
}));

// Forcing change for DevOps

export default function SmartTableToolbar(props) {
	const dispatch = useDispatch();
	const { t } = useTranslation();
    const { id, title, titleVariant, subTitle, subTitleVariant, numSelected, addNew } = props;

    const [hasSubHeading, setHasSubHeading] = useState(subTitle ? true : false);
	const [addButtonEnabled, setAddButtonEnabled] = useState(addNew?.enabled !== undefined ? addNew.enabled : false);

    const titleV = titleVariant !== null ? titleVariant : "h6";
    const subTitleV = subTitleVariant !== null ? subTitleVariant : "subtitle1";

    const cardHeaderStyle = {};
    if (!hasSubHeading) {
        cardHeaderStyle.minHeight = '48px';
    }

	const clickHandler = () => {
		const modelConfig = {
			title: addNew.config.title,
			parent: addNew.config.parent,
			paper: addNew.config.paper,
			button: null,
			content: <Construct layout={{configuration: addNew.config.component}} />,
			tooltipContent: ""
		}

		dispatch(appSetModalContent(modelConfig));
	}

    return (
        <StyledToolbar className={clsx(classes.root)} style={cardHeaderStyle}>
            <div className={classes.headerContent}>
                <Typography className={classes.title} variant={titleV} color="textPrimary" id="tableTitle">
                    {t(title)}
                </Typography>
                <Typography className={classes.title} variant={subTitleV} color="textSecondary" id="tableSubTitle">
                    {t(subTitle)}
                </Typography>
            </div>
            <div className={classes.headerAction}>
                <Typography>
                    {ClearFilterBtn(id, false)}
                </Typography>
            </div>
			{addButtonEnabled &&
				<Tooltip title={addNew.config.tooltip}>
					<IconButton aria-label={addNew.config.tooltip} onClick={() =>{ clickHandler() }}>
						<AddIcon/>
					</IconButton>
				</Tooltip>
			}
        </StyledToolbar>
    );
}

SmartTableToolbar.propTypes = {
    title: PropTypes.string.isRequired,
    numSelected: PropTypes.number.isRequired,
};
